import React from 'react';
import {
  BenefitsBadge, BenefitsBadgeVariantValue, CardLayout, CardLayoutSize, DetailGrid, DetailGridSkeleton,
} from '../../../shared/components';
import { HouseholdCardDetail, HouseholdCardStatusValues } from '../streetview.type';

const columnWidth = 204;

export interface HouseholdCardProps {
  householdReference: string,
  benefitsVariant: BenefitsBadgeVariantValue,
  detail: HouseholdCardDetail,
  onClose: () => void,
  actionMenu?: React.ReactNode,
}

// Street View card for one household: its reference, benefits badge and details. Display only
export default function HouseholdCard({
  householdReference, benefitsVariant, detail, onClose, actionMenu,
}: Readonly<HouseholdCardProps>) {
  const isLoaded = detail.status === HouseholdCardStatusValues.Loaded;

  return (
    <CardLayout
      title="Household Reference"
      size={CardLayoutSize.Fit}
      headerContent={(
        <>
          <span className="font-sans text-xl leading-[26px] font-semibold text-piptext-default">
            {householdReference}
          </span>
          <BenefitsBadge variant={benefitsVariant} />
        </>
      )}
      onClose={onClose}
      closeLabel="Close household details"
      footer={isLoaded ? actionMenu : undefined}
      showFooterDivider={false}
    >
      {detail.status === HouseholdCardStatusValues.Loading && (
        <output className="block">
          <DetailGridSkeleton columnWidth={columnWidth} />
          <span className="sr-only">Loading household details…</span>
        </output>
      )}
      {detail.status === HouseholdCardStatusValues.Error && (
        <p role="alert" className="text-body-regular text-piptext-error">{detail.message}</p>
      )}
      {isLoaded && <DetailGrid items={detail.items} columnWidth={columnWidth} />}
    </CardLayout>
  );
}
